var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "popover", rawName: "v-popover:popover", arg: "popover" }
      ],
      staticClass: "lang-selector",
      style: _vm.istyle
    },
    [
      _c("li", {
        class: _vm.icon,
        staticStyle: { padding: "8px" },
        style: _vm.iconStyle,
        attrs: { size: _vm.size }
      }),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: { placement: "bottom-start", trigger: _vm.trigger },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "item",
              on: {
                click: function($event) {
                  return _vm.changeLanguage("zh_cn")
                }
              }
            },
            [_vm._v("简体中文")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item",
              on: {
                click: function($event) {
                  return _vm.changeLanguage("en_us")
                }
              }
            },
            [_vm._v("English")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0695e340", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0695e340","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangSelector/index.vue
// module id = null
// module chunks = 